import { ActionTypes } from '../../../constants';

export const setThematicSelectionList = (thematicSelectionList: Array<Object>) => {
  return {
    type: ActionTypes.SET_THEMATIC_SELECTION_LIST,
    thematicSelectionList,
  };
};
